// Default algorithm list - fallback when API request fails
export const DEFAULT_ALGORITHMS = {
  'capacitated_cluster_first_route_second': {
    name: 'Capacitated Cluster First Route Second Algorithm',
    description: 'First group locations with capacity constraints, then plan routes for each group'
  },
  'capacitated_savings': {
    name: 'Capacitated CW Savings Algorithm',
    description: 'Multi-vehicle routing with capacity limits'
  },
  'capacitated_cluster': {
    name: 'Capacitated Cluster Algorithm', 
    description: 'Cluster first, then route each group'
  }
}; 